// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CustomerDetailModal_modalContainer__1YdCC .am-modal-content{border-radius:26px !important}.CustomerDetailModal_wrapper__1ZMIJ{max-width:450px;margin:auto}", "",{"version":3,"sources":["webpack://./src/bepaid/shared/modals/CustomerDetailPageModal/CustomerDetailModal.module.scss"],"names":[],"mappings":"AAAA,6DAA0C,6BAA6B,CAAC,oCAAS,eAAe,CAAC,WAAW","sourcesContent":[".modalContainer :global .am-modal-content{border-radius:26px !important}.wrapper{max-width:450px;margin:auto}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalContainer": "CustomerDetailModal_modalContainer__1YdCC",
	"wrapper": "CustomerDetailModal_wrapper__1ZMIJ"
};
export default ___CSS_LOADER_EXPORT___;
